<template>
  <span :class="['tm-badge-content', `tm-badge-content--shrink-${shrink}`, { 'tm-badge-content--with-icon': icon }]">
    <tm-icon
      v-if="icon"
      :name="icon"
      class="tm-badge-content__icon"
      size="small"
    />
    <highlight
      v-if="label"
      class="tm-badge-content__label"
      :class="{
        [`tm-badge-content__label--text-${textTransform}`]: textTransform,
      }"
      :title="label && `${label}`.length > 20 ? `${label}` : undefined"
      :text="`${label}`"
      :search="searchQuery"
    />
    <span
      v-if="additionalText"
      class="tm-badge-content__additional-text truncate"
      :class="{ [`tm-badge-content__additional-text--text-visible`]: additionalTextVisible }"
    >
      {{ additionalText }}
    </span>
  </span>
</template>

<script setup lang="ts">
import TmIcon from '@/components/shared/TmIcon.vue'
import { TmBadgeContentProps } from '@/components/shared/badge/types'
import Highlight from '@/components/shared/misc/Highlight.vue'

defineProps(TmBadgeContentProps)
</script>

<style lang="scss" scoped>
@import '@/styles/mixins';
.tm-badge-content {
  @include tm-badge-content;
}
</style>
